<div class="no-data" >
  <img class="no-data-icon" src="{{assetsUrl}}assets/images/{{imagename}}.svg" alt="altname">
  <h2 class="heading" [innerHTML]="h2"></h2>
  <p [innerHTML]="p"></p>
</div>